module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showHeader) ? _c('j-header', {
    on: {
      "pop": _vm.pop
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    on: {
      "header": _vm.header,
      "footer": _vm._footer
    }
  }), _vm._v(" "), (_vm.showFooter) ? _c('j-footer') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popping),
      expression: "popping"
    }],
    staticClass: "app_pop"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "7px",
      "width": "50px",
      "height": "50px",
      "line-height": "50px"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mask),
      expression: "mask"
    }],
    staticClass: "mask",
    on: {
      "click": _vm._mask
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a443973a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 293
// module chunks = 1